import styled from 'styled-components'

import { getSpacing } from '../../../../../style/styleMixins/offset'

export const SGallery = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: ${getSpacing(2)};

  @media ${(p) => p.theme.breakpoints.mobile} {
    img {
      max-width: 270px;
      max-height: 300px;
    }
  }

  @media (max-width: 664px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`
